export default __webpack_public_path__ + "static/assets/fa9927e2c704d41dcf28815312e3241b.svg";